var map = {
	"./amulets_and_talismans.png": 1681,
	"./archaeological_objects.png": 7824,
	"./architectural_elements.png": 8180,
	"./arms_and_armoury.png": 6646,
	"./calligraphy.png": 2285,
	"./carpets.png": 6555,
	"./ceramics.png": 377,
	"./clothing_and_costume.png": 1519,
	"./coins_and_medals.png": 8522,
	"./communication_and_transportation.png": 4526,
	"./funerary_objects.png": 7933,
	"./furniture_and_woodwork.png": 5153,
	"./glass.png": 8966,
	"./gold_and_silver.png": 2942,
	"./historical_cars.png": 3786,
	"./ivory.png": 7365,
	"./jewellery.png": 833,
	"./landscapes.png": 7037,
	"./leatherwork.png": 7769,
	"./manuscripts.png": 4544,
	"./metalwork.png": 6702,
	"./mosaics.png": 8404,
	"./musical_instruments.png": 8176,
	"./paintings.png": 3157,
	"./photographs.png": 3635,
	"./porcelain.png": 8842,
	"./portraits.png": 2218,
	"./precious_stones.png": 2888,
	"./prints_and_drawings.png": 431,
	"./religious_life.png": 5093,
	"./scientific_objects.png": 9786,
	"./sculptures.png": 6519,
	"./textiles.png": 7483,
	"./theatre.png": 4418,
	"./toys.png": 8899,
	"./wall_paintings_and_frescoes.png": 7967,
	"./weights_and_measures.png": 2059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9370;